var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4629 1.67578C19.4863 1.78039 19.5 1.88869 19.5 2V14C19.5 14.8239 18.8239 15.5 18 15.5H2C1.17614 15.5 0.5 14.8239 0.5 14V2C0.5 1.88877 0.512782 1.78033 0.536133 1.67578L1.73535 2.42383L9.73535 7.41406L10 7.5791L10.2646 7.41406L18.2646 2.42383L19.4629 1.67578ZM17.7354 3.57617L10 8.41016L2.26465 3.57617L1.5 3.09766V14.5H18.5V3.09766L17.7354 3.57617ZM2 0.5H18C18.6487 0.5 19.2045 0.919607 19.4121 1.5H0.587891C0.795486 0.919607 1.35133 0.5 2 0.5Z",
    fill: "#FD9D03",
    stroke: "#FD9D03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f446aa03a611e21314d14164e2c169f0.svg";
export { ForwardRef as ReactComponent };